import React from "react";

// ROB LEVEL 1-10 color bands (community reputation, non-monetary).
function levelColor(level) {
  if (level >= 9) return "bg-danger/15 text-danger border-danger";
  if (level >= 7) return "bg-grape/20 text-grape border-grape";
  if (level >= 5) return "bg-gold/15 text-gold border-gold";
  if (level >= 3) return "bg-neon/15 text-neon border-neon";
  return "bg-ink3 text-cream border-charcoal";
}

export default function BadgeTag({ rob, className = "" }) {
  if (!rob) return null;
  const level = rob.level || 1;
  return (
    <span
      className={`inline-flex items-center gap-1 border-2 px-1.5 py-0.5 font-heading font-bold uppercase text-[9px] leading-none ${levelColor(level)} ${className}`}
      title={`ROB LEVEL ${level} · ${rob.name || ""}`}
      data-testid="rob-level-tag"
    >
      LVL {level}
    </span>
  );
}
